
export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/b1c29a4fc7044e2ba6cf7d78df0dd033.jpg"
          alt="團隊挑戰"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 mt-16">
        <div className="max-w-3xl">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6">
            不只是在辦活動，
            <br />
            我們協助您打造
            <br />
            高績效的團隊
          </h1>
          <p className="text-xl md:text-2xl text-white/90 mb-12 font-light">
            讓團隊敢承諾、敢行動、敢承擔、敢突破
          </p>
          <div className="flex flex-wrap gap-4">
            <button
              onClick={() => scrollToSection('services')}
              className="bg-orange-500 text-white px-8 py-4 rounded-full font-semibold hover:bg-orange-600 transition-all duration-300 flex items-center gap-2 whitespace-nowrap cursor-pointer"
            >
              探索我們的服務
              <i className="ri-arrow-right-line"></i>
            </button>
            <a
              href="https://youtu.be/ei0JSFLfFA0"
              target="_blank"
              rel="noopener noreferrer"
              className="border-2 border-white text-white px-8 py-4 rounded-full font-semibold hover:bg-white hover:text-black transition-all duration-300 flex items-center gap-2 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-circle-line"></i>
              觀看案例影片
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
